import { render, staticRenderFns } from "./CollaborationParticipants.vue?vue&type=template&id=496244c4&scoped=true&"
import script from "./CollaborationParticipants.vue?vue&type=script&lang=js&"
export * from "./CollaborationParticipants.vue?vue&type=script&lang=js&"
import style0 from "./CollaborationParticipants.vue?vue&type=style&index=0&id=496244c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496244c4",
  null
  
)

export default component.exports